<mat-card>
    <mat-card-header>
        <mat-card-title>{{ message }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-card-actions>
            <button mat-raised-button *ngIf="this.redirect != undefined" (click)="okRedirect()" color="accent" tabindex="-1"><mat-icon>open_in_new</mat-icon></button>
            <button mat-raised-button (click)="ok()" color="primary" tabindex="-1">Ok</button>
        </mat-card-actions>
    </mat-card-content>
</mat-card>